import { useState, useEffect } from 'react';
import { NavItemType } from 'types';
import viewsPages from 'menu-items/views-pages';
import { loadDynamicExternalApps } from 'menu-items/dynamic-external-apps';
import { getSidebarPagesNavGroup } from 'menu-items/sidebar-pages';

// Hook שמנהל את התפריט באופן דינמי
export const useDynamicMenuItems = () => {
  const [menuItems, setMenuItems] = useState<{ items: NavItemType[] }>({
    items: [viewsPages, getSidebarPagesNavGroup()],
  });

  // פונקציה שמעדכנת את התפריט
  const updateMenuItems = () => {
    setMenuItems({
      items: [viewsPages, getSidebarPagesNavGroup()],
    });
  };

  // טעינת הרחבות מהשרת בעת טעינת הקומפוננטה
  useEffect(() => {
    loadDynamicExternalApps().then(() => {
      updateMenuItems();
    });
  }, []);

  // האזנה לשינויים באפליקציות חיצוניות
  useEffect(() => {
    const handleExternalAppsUpdate = () => {
      updateMenuItems();
    };

    // האזנה לאירוע מותאם אישית שנפלט כשמעדכנים אפליקציות
    window.addEventListener('externalAppsUpdated', handleExternalAppsUpdate);

    // ניקוי listeners כשה-component נמחק
    return () => {
      window.removeEventListener('externalAppsUpdated', handleExternalAppsUpdate);
    };
  }, []);

  return menuItems;
}; 